import { MarketingPage } from './Chrome';
import styles from './Marketing.module.css';

export function AboutPage() {
  return (
    <MarketingPage>
      <h1 className={styles.sectionTitle}>About Resonance</h1>
      <div className={styles.prose}>
        <p>
          Most CRMs are filing cabinets that bill you for the privilege of keeping them tidy.
          The work — the follow-up, the notes, the updates that keep everything honest — still
          lands on you.
        </p>
        <p>
          Resonance starts from the other end. Every person gets an AI counterpart, their Echo,
          that does that work and writes down what it did. You talk to it the way you would talk
          to a capable colleague, and you can see and undo everything it touched.
        </p>
        <p>
          We are building toward two standards: that the system is natural enough to talk to that
          you never think twice, and consistent enough in execution that you never think twice
          about trusting it.
        </p>
      </div>
    </MarketingPage>
  );
}
